import { render, staticRenderFns } from "./InvitationResponse.vue?vue&type=template&id=86ceeb50&scoped=true"
import script from "./InvitationResponse.vue?vue&type=script&lang=js"
export * from "./InvitationResponse.vue?vue&type=script&lang=js"
import style0 from "./InvitationResponse.vue?vue&type=style&index=0&id=86ceeb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ceeb50",
  null
  
)

export default component.exports